import React from 'react';
import { Card, Skeleton } from 'antd';
import { trpc } from '../../lib/trpc';
import CompanyInfoTab from '../../components/company/CompanyInfoTab';
import { PageHeader, PageContainer, DevFilePathBadge } from '../../components/common';

const CompanyInfoPage: React.FC = () => {
  const { data: company, isLoading } = trpc.company.getCurrentCompany.useQuery();
  const { data: currentUser } = trpc.user.getProfile.useQuery();
  const isManager = currentUser?.role === 'admin' || currentUser?.role === 'manager';

  if (isLoading) {
    return (
      <PageContainer>
        <PageHeader
          title="会社情報"
          subtitle="会社情報の確認・編集を行います"
        />
        <Card>
          <Skeleton active />
        </Card>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <DevFilePathBadge filePath="client/src/pages/settings/CompanyInfoPage.tsx" />
      <PageHeader
        title="会社情報"
        subtitle="会社情報の確認・編集を行います"
      />
      <Card>
        <CompanyInfoTab company={company} isManager={isManager} />
      </Card>
    </PageContainer>
  );
};

export default CompanyInfoPage;
